module.exports = require("@swa-ui/placements/src/Banner/BannerLayout2.module.scss");